import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CTA_BG = 'http://geel.fp.08wx.cn/images/7997b84525f30b4f75269ab47db6333f.jpg';

const badges = [
  { icon: 'ri-building-line', key: 'cta.badge1' },
  { icon: 'ri-time-line', key: 'cta.badge2' },
  { icon: 'ri-customer-service-2-line', key: 'cta.badge3' },
  { icon: 'ri-code-s-slash-line', key: 'cta.badge4' },
];

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img src={CTA_BG} alt="CTA background" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/75 to-white/85" />
        <div className="absolute inset-0 grid-bg opacity-30" />
      </div>
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-80 h-80 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-64 h-64 bg-accent/10 rounded-full blur-3xl pointer-events-none" />
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl xl:text-6xl font-heading font-bold text-gray-900 mb-6 leading-tight">{t('cta.title')}</h2>
        <p className="text-gray-500 text-lg md:text-xl mb-10 max-w-2xl mx-auto">{t('cta.subtitle')}</p>
        <div className="flex flex-wrap items-center justify-center gap-4 mb-14">
          <Link to="/contact" className="inline-flex items-center gap-2 px-9 py-4 bg-primary hover:bg-primary-dark text-white font-bold text-base rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer">
            {t('cta.btn')} <i className="ri-arrow-right-line" />
          </Link>
          <Link to="/products" className="inline-flex items-center gap-2 px-9 py-4 border border-primary/40 hover:border-primary text-primary font-semibold text-base rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer bg-white/60 hover:bg-primary/5">
            {t('cta.btn2')} <i className="ri-eye-line" />
          </Link>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3">
          {badges.map((badge, i) => (
            <div key={i} className="flex items-center gap-2 px-5 py-2.5 bg-white/80 border border-primary-200 rounded-full backdrop-blur-sm">
              <i className={`${badge.icon} text-primary text-sm`} />
              <span className="text-gray-600 text-sm whitespace-nowrap">{t(badge.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
